module.exports = __webpack_public_path__ + "img/payment.9a379b56.svg";